import {
  USER_FIND_REQUESTED,
  USER_FIND_SUCCESS,
  USER_FIND_FAILURE,
  USERS_INDEX_REQUESTED,
  USERS_INDEX_SUCCESS,
  USERS_INDEX_FAILURE,
  USER_CREATE_REQUESTED,
  USER_CREATE_SUCCESS,
  USER_CREATE_FAILURE,
  USER_DELETE_REQUESTED,
  USER_DELETE_SUCCESS,
  USER_DELETE_FAILURE,
  USER_UPDATE_REQUESTED,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAILURE,
} from '../types';

const userPayload = (payload) => {
  const rawUser = payload && payload.user;
  const parsedUser = typeof rawUser === 'string' ? JSON.parse(rawUser) : rawUser;

  return parsedUser || null;
}

const INITIAL_STATE = {
  user: null,
  users: null,
  isFetching: false,
  isCreating: false,
  updatingUser: null,
  deletingUser: null,
  status: 'waiting',
  errors: null
};

const users = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case USER_FIND_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting'
      });

    case USER_FIND_SUCCESS:
      return Object.assign({}, state, {
        user: action.payload,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case USER_FIND_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        errors: 'error here'
      })

    case USERS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting'
      })

    case USERS_INDEX_SUCCESS:
      return Object.assign({}, state, {
        users: action.payload,
        isFetching: false,
        status: 'success',
        errors: null
      })

    case USER_CREATE_REQUESTED:
      return Object.assign({}, state, {
        isCreating: true,
        errors: null
      })

    case USER_CREATE_SUCCESS: {
      const newUser = userPayload(action.payload);

      return Object.assign({}, state, {
        users: newUser ? [...(state.users || []), newUser] : state.users,
        isCreating: false,
        status: 'success',
        errors: null
      })
    }

    case USER_CREATE_FAILURE:
      return Object.assign({}, state, {
        isCreating: false,
        errors: 'Could not create user'
      })

    case USER_UPDATE_REQUESTED:
      return Object.assign({}, state, {
        updatingUser: action.email,
        errors: null
      })

    case USER_UPDATE_SUCCESS: {
      const updatedUser = userPayload(action.payload);

      return Object.assign({}, state, {
        users: updatedUser
          ? (state.users || []).map((user) => user.email === updatedUser.email ? updatedUser : user)
          : state.users,
        updatingUser: null,
        status: 'success',
        errors: null
      })
    }

    case USER_UPDATE_FAILURE:
      return Object.assign({}, state, {
        updatingUser: null,
        errors: 'Could not update user'
      })

    case USER_DELETE_REQUESTED:
      return Object.assign({}, state, {
        deletingUser: action.email,
        errors: null
      })

    case USER_DELETE_SUCCESS:
      return Object.assign({}, state, {
        users: (state.users || []).filter((user) => user.email !== action.payload),
        deletingUser: null,
        status: 'success',
        errors: null
      })

    case USER_DELETE_FAILURE:
      return Object.assign({}, state, {
        deletingUser: null,
        errors: 'Could not delete user'
      })

    default:
      return state;
  }
}

export default users;
